import {ERROR, START, SUCCESS} from "../../../../constants/action-postfix";
import {PRIVILEGES_REQUEST} from "../privilegesReducer";


const initialState = false;

export const privilegesLoaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${PRIVILEGES_REQUEST}${START}`:
            return true;
        case `${PRIVILEGES_REQUEST}${SUCCESS}`:
            return false;
        case `${PRIVILEGES_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};